import React from 'react'
import styled from 'styled-components'
import { CurrencySymbolImage, PairImage } from '../../input'
import { FontWeights } from '../../../constants'
import { timeAgo } from '../../../utils'

interface Props {
  description: string
  now: Date
  symbol0: string
  symbol1?: string
  submittedAt: number
}

export function SingleItem({ description, now, symbol0, symbol1, submittedAt }: Props) {
  return (
    <Header>
      <Description>{description}</Description>
      <Details>
        <SubmittedAt>{timeAgo(now, new Date(submittedAt))}</SubmittedAt>
        <Tokens>
          {symbol1 ? (
            <>
              <PairImage currencySymbol={symbol0} otherSymbol={symbol1} />
              {symbol0}-{symbol1}
            </>
          ) : (
            <>
              <CurrencySymbolImageStyled symbol={symbol0} />
              {symbol0}
            </>
          )}
        </Tokens>
      </Details>
    </Header>
  )
}

const Header = styled.div`
  margin-bottom: 5px;
  display: flex;
  align-items: space-between;
`

const Description = styled.span`
  padding-right: 10px;
  font-size: 15px;
  font-weight: ${FontWeights.Bold};
`

const Details = styled.div`
  margin-left: auto;
  flex-shrink: 0;
  text-align: right;
`

const SubmittedAt = styled.div`
  margin-bottom: 5px;
  font-size: 12px;
  font-weight: ${FontWeights.Bold};
`

const Tokens = styled.div`
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: ${FontWeights.Bold};
`

const CurrencySymbolImageStyled = styled(CurrencySymbolImage)`
  margin-right: 5px;
`
